import { Button, Grid, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../app/hooks/hooks';
import { getPartnerId } from '../../../app/store/combinedSelectors';
import { goToClaimsBtn } from '../../../Constants/Constants';
import { PostMessageCodes } from '../../../Constants/PostMessageCodes';
import { IconStateType, PartnerId } from '../../../types/type';
import { postMessageToParentApp } from '../../../utils/Utilities';
import ConfirmationHeader from '../../shared/ConfirmationHeader/ConfirmationHeader';
import ModalLinearActivityIndicator from '../../shared/ModalLinearActivityIndicator/ModalLinearActivityIndicator';

export default function AdjusterConfirmation(props: any) {
  const navigate = useNavigate();
  const theme = useTheme();
  const [modalLoadingOpen, setModalLoadingOpen] = React.useState(false);
  const claimSummary = useAppSelector((state) => state.claimDetail.claimSummary);
  const partnerId = useSelector(getPartnerId);

  async function goToClaimsOverview() {
    if (partnerId?.toUpperCase() === PartnerId.AFICS) {
      setModalLoadingOpen(true);
      postMessageToParentApp(
        PostMessageCodes.DIGITAL_CLAIM_POST_FNOL_GO_TO_CLAIMS,
        undefined,
        undefined,
        claimSummary?.policyNumber
      );
    } else {
      navigate('/claims-overview', {
        state: {
          isClaimRefreshNeeded: true,
        },
      });
    }
  }

  const headerContent = props.success
    ? 'Your information was successfully sent.'
    : "We're having trouble contacting your adjuster.";

  return (
    <Box sx={{ width: '100%' }}>
      <Grid
        container
        sx={{
          width: '100%',
          maxWidth: '1280px',
          minWidth: '310px',
          margin: '0 auto',
        }}
      >
        <Grid item xs={12}>
          <ConfirmationHeader
            headerContent={headerContent}
            state={props.success ? IconStateType.SUCCESS_STATE : IconStateType.FAIL_STATE}
          ></ConfirmationHeader>
        </Grid>

        {!!props.success && (
          <>
            <Grid item xs={12}>
              <Typography sx={{ marginTop: '20px' }} variant="body1">
                Here is a copy of your message.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ marginTop: '20px' }} variant="body1">
                <b>Message:</b>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ marginTop: '20px' }} variant="body1">
                {props.comment}
              </Typography>
            </Grid>
          </>
        )}

        {!props.success && (
          <Grid item xs={12}>
            <Typography sx={{ marginTop: '20px' }} variant="body1">
              Try again in a few minutes, or contact us for assistance.
            </Typography>
          </Grid>
        )}
        <Grid
          sx={{
            marginTop: '2em',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'left',
          }}
          item
          xs={12}
        >
          <Button
            sx={{
              ...theme.custom.styles.genericPrimaryButton,
            }}
            onClick={() => goToClaimsOverview()}
          >
            {goToClaimsBtn}
          </Button>
        </Grid>
      </Grid>
      {modalLoadingOpen && <ModalLinearActivityIndicator />}
    </Box>
  );
}
